import React from 'react';
import { useTenant } from '../../../context/TenantContext';
import { warmInlineEm } from './warmInlineEm';

const DEFAULT_STEPS = [
  { title: 'Find a programme', body: 'Browse our short, focused courses. Each runs for 4–8 weeks with weekly live sessions.' },
  { title: 'Join a cohort', body: 'You will be placed with 20–30 other learners. We pay attention to making cohorts feel right.' },
  { title: 'Make something real', body: 'Every course ends in a project, a piece of work, or a habit you have actually built.' },
];

export const WarmSteps: React.FC = () => {
  const { tenant } = useTenant();
  const marketing = tenant?.branding.marketing;
  const tenantSteps = marketing?.steps?.filter(s => s.title?.trim());
  const steps = tenantSteps && tenantSteps.length > 0 ? tenantSteps : DEFAULT_STEPS;
  if (marketing?.steps?.length === 0) return null;

  const stepCount = steps.length;
  const gridCols = stepCount === 4 ? 'md:grid-cols-4' : 'md:grid-cols-3';

  return (
    <section id="steps" className="warm-steps py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14 md:mb-16">
          <div className="font-warm-hand text-2xl text-[var(--warm-accent-deep)] mb-2 -rotate-1 inline-block">
            Three simple steps
          </div>
          <h2 className="font-warm-serif text-3xl md:text-5xl leading-[1.05] tracking-tight text-[var(--warm-ink)] max-w-[22ch] mx-auto text-balance">
            It works <em className="warm-em">like this</em>.
          </h2>
        </div>

        <div className={`relative grid grid-cols-1 ${gridCols} gap-9`}>
          {/* Dotted connector — hidden on mobile */}
          <span className="hidden md:block absolute top-9 left-[16%] right-[16%] border-t-[2.5px] border-dashed border-[var(--warm-accent-soft)]" />

          {steps.map((step, i) => (
            <div key={i} className="relative text-center bg-[var(--warm-paper)] px-3">
              <div className="warm-step-circle inline-flex items-center justify-center w-[72px] h-[72px] rounded-full bg-white border-[2.5px] border-[var(--warm-accent)] mb-6 font-warm-serif text-3xl text-[var(--warm-accent-deep)] shadow-[0_6px_18px_rgba(217,119,87,0.2)]">
                {i + 1}
              </div>
              <h3 className="font-warm-serif text-2xl text-[var(--warm-ink)] mb-3 leading-tight">
                {warmInlineEm(step.title)}
              </h3>
              <p className="text-[var(--warm-ink-soft)] max-w-[32ch] mx-auto leading-relaxed">
                {step.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
